function extractErrorMessage(result) {
  const data = result?.data;
  if (data && typeof data === 'object' && data.message) return data.message;
  if (typeof data === 'string' && data.trim()) return data.trim();
  if (result?.message) return result.message;
  return 'Nộp điểm DTI thất bại. Hãy cập nhật dữ liệu trước khi nộp.';
}

export function getSubmitFeedback(result) {
  if (result?.success) {
    return {
      ok: true,
      message: result.message || 'Đã nộp điểm DTI thành công',
    };
  }
  return {
    ok: false,
    message: extractErrorMessage(result),
  };
}
